import * as actions from '../../actions/actions'

const initialState = {
  bankDetail: {
    bankId: '',
    bankName: '',
    bankContact: '',
    enabled: false,
    corporates: [],
    bankImage:''
  },
  error: ''
}

export default function bankDetail(state = initialState, action) {
  switch (action.type) {
    case actions.FETCH_BANK_DETAIL_SUCCESS:
      return fetchBankDetailSuccess(state, action)
    case actions.FETCH_BANK_DETAIL_FAILURE:
      return fetchBankDetailFailure(state, action)
    case actions.DETAIL_BANK_CLEAN:
      return detailBankClean(state, action)
    default:
      return state
  }
}

const fetchBankDetailSuccess = (state, action) => {
  return {
    ...state,
    bankDetail: action.value
  }
}

const fetchBankDetailFailure = (state, action) => {
  return {
    ...state,
    error: action.error
  }
}

const detailBankClean = (state, action) => {
  return initialState;
}